export default {
    path: 'template_report',
    name: 'template_report',
    component: r => require.ensure([], () => r(require('./index.vue')), 'template_report'),
    redirect: {name: 'template_report_list'},
    children: [
        {
            path: 'template_report_list',
            name: 'template_report_list',
            component: r => require.ensure([], () => r(require('./list.vue')), 'template_report_list'),
        }
    ]
}
